import type { CompRef } from 'types/documentServices';
import type { EditorAPI } from '#packages/editorAPI';
import type { LayoutGetApi } from './layoutGetApi';

export function createLayoutMeasureApi({
  editorAPI,
  layoutGetApi,
}: {
  editorAPI: EditorAPI;
  layoutGetApi: LayoutGetApi;
}) {
  /**
   * Get components bounding box relative to screen.
   * Bounding box layout is different when component is rotated.
   */
  const getBoundingLayoutRelativeToScreen = (compRef: CompRef | CompRef[]) => {
    const layout = layoutGetApi.getRelativeToScreen_rect(compRef);
    const rotationInDegrees = layoutGetApi.get_rotationInDegrees(compRef);
    return editorAPI.utils.getBoundingLayout({ ...layout, rotationInDegrees });
  };

  /**
   * Get components bounding box relative to container.
   * Bounding box layout is different when component is rotated.
   */
  const getBoundingLayout = (compRef: CompRef | CompRef[]) => {
    const layout = layoutGetApi.get_rect(compRef);
    const rotationInDegrees = layoutGetApi.get_rotationInDegrees(compRef);
    return editorAPI.utils.getBoundingLayout({ ...layout, rotationInDegrees });
  };

  return {
    getBoundingLayout,
    getBoundingLayoutRelativeToScreen,
  };
}

export type LayoutMeasureApi = ReturnType<typeof createLayoutMeasureApi>;
